import { api } from './api';
import { cuitDigits } from '../utils/format';

/**
 * Solicita el envío del código OTP de recuperación de contraseña.
 *
 * Login por CUIT: la recuperación exige CUIT + correo (el correo ya no es único;
 * el CUIT desambigua la cuenta). Pega al backend `POST /api/auth/forgot-password`,
 * que verifica el par, genera el código con Supabase (admin.generateLink sobre la
 * identidad sintética) y lo envía al correo real vía Envialo Simple (decisión
 * #037). El backend responde siempre de forma genérica (no revela si el par
 * existe), así que esta función resuelve salvo error de red o del servidor.
 */
export async function requestPasswordRecovery(cuit: string, email: string): Promise<void> {
  await api.post('/auth/forgot-password', {
    cuit: cuitDigits(cuit),
    email: email.trim().toLowerCase(),
  });
}
